import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import { batchLoadGalleries, batchEditGallery } from '../../../actions/studio';
import { Props } from './GalleryBatchEdit';
import { AppState } from '../../../types/store';

export type StateProps = Pick<Props, 'galleries' | 'isLoading'>;
export type DispatchProps = Pick<
  Props,
  'batchLoadGalleries' | 'batchEditGallery'
>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => ({
  galleries: state.studio!.galleries,
  isLoading: state.studio!.batchActionLoading,
});

const mapDispatchToProps: MapDispatchToProps<
  DispatchProps,
  OwnProps
> = dispatch => ({
  batchLoadGalleries: () => dispatch(batchLoadGalleries()),
  batchEditGallery: (targetFolderId: number[]) =>
    dispatch(batchEditGallery(targetFolderId)),
});

export default connect(mapStateToProps, mapDispatchToProps);
